/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationReference } from './HomeHealthCertificationReference';
import {
    HomeHealthCertificationReferenceFromJSON,
    HomeHealthCertificationReferenceFromJSONTyped,
    HomeHealthCertificationReferenceToJSON,
    HomeHealthCertificationReferenceToJSONTyped,
} from './HomeHealthCertificationReference';

/**
 * 
 * @export
 * @interface HomeHealthCertificationPrimaryReasonForHomeHealth
 */
export interface HomeHealthCertificationPrimaryReasonForHomeHealth {
    /**
     * 
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     */
    summary: string;
    /**
     * 
     */
    ref: Array<HomeHealthCertificationReference>;
}



/**
 * Check if a given object implements the HomeHealthCertificationPrimaryReasonForHomeHealth interface.
 */
export function instanceOfHomeHealthCertificationPrimaryReasonForHomeHealth(value: object): value is HomeHealthCertificationPrimaryReasonForHomeHealth {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('ref' in value) || value['ref'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationPrimaryReasonForHomeHealthFromJSON(json: any): HomeHealthCertificationPrimaryReasonForHomeHealth {
    return HomeHealthCertificationPrimaryReasonForHomeHealthFromJSONTyped(json, false);
}

export function HomeHealthCertificationPrimaryReasonForHomeHealthFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationPrimaryReasonForHomeHealth {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'summary': json['summary'],
        'ref': ((json['ref'] as Array<any>).map(HomeHealthCertificationReferenceFromJSON)),
    };
}

export function HomeHealthCertificationPrimaryReasonForHomeHealthToJSON(json: any): HomeHealthCertificationPrimaryReasonForHomeHealth {
    return HomeHealthCertificationPrimaryReasonForHomeHealthToJSONTyped(json, false);
}

export function HomeHealthCertificationPrimaryReasonForHomeHealthToJSONTyped(value?: HomeHealthCertificationPrimaryReasonForHomeHealth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'summary': value['summary'],
        'ref': ((value['ref'] as Array<any>).map(HomeHealthCertificationReferenceToJSON)),
    };
}

